import QueryParams from '@backoffice/services/QueryParams'

export const BACKOFFICE_MIXIN_CONFIG = {
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
  paramsSerializer: (params) =>
    QueryParams.stringifyQueryParams(params, {
      addQueryPrefix: false,
      arrayFormat: 'brackets',
    }),
}
